import styled from 'styled-components';

const Container = styled.div``;

const Deals = () => <Container />;

export default Deals;
